/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Who_Fc_3Inputs */

const en_fc_vs_who_fc_3 = /** @type {(inputs: Fc_Vs_Who_Fc_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`already know Premiere and want the same muscle memory for free`)
};

/**
* | output |
* | --- |
* | "already know Premiere and want the same muscle memory for free" |
*
* @param {Fc_Vs_Who_Fc_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_who_fc_3 = /** @type {((inputs?: Fc_Vs_Who_Fc_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Who_Fc_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_who_fc_3(inputs)
});
export { fc_vs_who_fc_3 as "fc.vs.who.fc.3" }